// Pricing snapshot from app-bolt/lib/catalogo.ts, 2026-09-25. Local demo only.
window.BoltCatalog=(()=>{const exports={};
"use strict";
// Catálogo de Bolt y reglas de precio.
// Fuente: la hoja de precios, costos y márgenes de ecommerce,
// pestañas BOLT RELAUNCH y OFERTAS BOLT, leída el 22/09/2026.
// El detalle y las advertencias están en docs/OFERTAS.md.
Object.defineProperty(exports, "__esModule", { value: true });
exports.familia = exports.altoEnPx = exports.ALTO_MAX = exports.productoPorId = exports.COMBOS_TRES = exports.UPSELL = exports.WHATSAPP = exports.REGALOS = exports.COMBOS = exports.ESCALERA = exports.PRODUCTOS = void 0;
exports.descuentoPorUnidades = descuentoPorUnidades;
exports.totalRedondeado = totalRedondeado;
exports.precioUnitario = precioUnitario;
exports.waMe = waMe;
exports.linkWhatsApp = linkWhatsApp;
exports.comboConUpsell = comboConUpsell;
exports.descuentoUnidad = descuentoUnidad;
exports.cotizar = cotizar;
exports.PRODUCTOS = [
    { id: 'whey-van', nombre: 'Whey Protein', sabor: 'Vainilla', servidas: 28, normal: 500, unidad: 440, total2: 800, total3: 1125, color: 'azul', ancho: 346, alto: 20, foto: '/productos/whey-van.webp', registro: 'B-42836' },
    { id: 'whey-cho', nombre: 'Whey Protein', sabor: 'Chocolate', servidas: 28, normal: 500, unidad: 440, total2: 800, total3: 1125, color: 'azul', ancho: 346, alto: 20, foto: '/productos/whey-cho.webp', registro: 'B-43939' },
    { id: 'fit-van', nombre: 'Fit Shake', sabor: 'Vainilla', servidas: 20, normal: 355, unidad: 315, total2: 565, total3: 800, color: 'celeste', ancho: 346, alto: 20, foto: '/productos/fit-van.webp', registro: 'B-42715' },
    { id: 'fit-cho', nombre: 'Fit Shake', sabor: 'Chocolate', servidas: 20, normal: 355, unidad: 315, total2: 565, total3: 800, color: 'celeste', ancho: 346, alto: 20, foto: '/productos/fit-cho.webp', registro: 'B-43940' },
    { id: 'gainer-van', nombre: 'Mass Gainer', sabor: 'Vainilla', servidas: 16, normal: 380, unidad: 340, total2: 605, total3: 855, color: 'naranja', ancho: 436, alto: 25, foto: '/productos/gainer-van.webp', registro: 'B-43153' },
    { id: 'gainer-cho', nombre: 'Mass Gainer', sabor: 'Chocolate', servidas: 16, normal: 380, unidad: 340, total2: 605, total3: 855, color: 'naranja', ancho: 436, alto: 25, foto: '/productos/gainer-cho.webp', registro: 'B-43149' },
    { id: 'crea-30', nombre: 'Creatina Monohidratada', sabor: 'Sin sabor', servidas: 30, normal: 140, unidad: 125, total2: 225, total3: 315, color: 'crema', ancho: 543, alto: 12.5, foto: '/productos/crea-30.webp', registro: 'B-42121' },
    { id: 'crea-60', nombre: 'Creatina Monohidratada', sabor: 'Sin sabor', servidas: 60, normal: 255, unidad: 225, total2: 410, total3: 575, color: 'crema', ancho: 543, alto: 12.5, foto: '/productos/crea-60.webp', registro: 'B-42121' },
    { id: 'pre-san', nombre: 'Pre Workout', sabor: 'Sandía ácida', servidas: 25, normal: 190, unidad: 170, total2: 305, total3: 430, color: 'rojo', ancho: 376, alto: 16, foto: '/productos/pre-san.webp', registro: 'B-46458' },
    { id: 'pre-man', nombre: 'Pre Workout', sabor: 'Manzana verde', servidas: 25, normal: 190, unidad: 170, total2: 305, total3: 430, color: 'rojo', ancho: 376, alto: 16, foto: '/productos/pre-man.webp', registro: 'B-49438' },
    { id: 'colageno', nombre: 'Colágeno Hidrolizado', sabor: 'Sin sabor', servidas: 30, normal: 200, unidad: 175, total2: 320, total3: 450, color: 'crema', ancho: 543, alto: 12.5, foto: '/productos/colageno.webp', registro: 'B-43150' },
    { id: 'amino', nombre: 'Amino Power', sabor: 'Blue Razz', servidas: 20, normal: 255, unidad: 225, total2: 410, total3: 575, color: 'verde', ancho: 376, alto: 16, foto: '/productos/amino.webp', registro: 'B-47615' },
];
/** Los escalones, para mostrarlos. 1 unidad es "hasta 12%": cada producto tiene su precio redondeado. */
exports.ESCALERA = [
    { unidades: 1, descuento: 12, texto: 'hasta 12%' },
    { unidades: 2, descuento: 20, texto: '20%' },
    { unidades: 3, descuento: 25, texto: '25%' },
    { unidades: 4, descuento: 30, texto: '30%' },
];
/**
 * Descuento por cantidad total de unidades en el pedido.
 * Las unidades PUEDEN ser de productos distintos.
 */
function descuentoPorUnidades(unidades) {
    if (unidades >= 4)
        return 0.3;
    if (unidades === 3)
        return 0.25;
    if (unidades === 2)
        return 0.2;
    return 0; // una unidad usa el precio de la tabla, no un porcentaje
}
/**
 * La regla de redondeo de la hoja (Francisco, 25/09): el total se lleva al
 * múltiplo de Q5. Hacia arriba si el descuento que queda, redondeado al
 * entero, sigue siendo el ofrecido (29.9% cuenta como 30%); si no (29.4%),
 * hacia abajo, aunque dé un poco más de descuento.
 */
function totalRedondeado(normalTotal, descuento) {
    const exacto = normalTotal * (1 - descuento);
    const arriba = Math.ceil(exacto / 5 - 1e-9) * 5;
    const queda = Math.round((1 - arriba / normalTotal) * 100);
    return queda >= Math.round(descuento * 100) ? arriba : Math.floor(exacto / 5 + 1e-9) * 5;
}
/**
 * Precio de UNA unidad de un producto dado el tamaño del pedido.
 *
 * 1 unidad: el precio de la hoja, redondeado a precio psicológico (de 10.5% a
 * 12.5% según el producto; ver docs/OFERTAS.md). 2 y 3: el total de la hoja
 * dividido entre 2 o 3. 4 o más: 30% con la regla de redondeo de la hoja.
 */
function precioUnitario(p, unidadesEnPedido) {
    if (unidadesEnPedido <= 1)
        return p.unidad;
    if (unidadesEnPedido === 2)
        return p.total2 / 2;
    if (unidadesEnPedido === 3)
        return p.total3 / 3;
    return totalRedondeado(p.normal * 4, 0.3) / 4;
}
exports.COMBOS = [
    { id: 'definicion', objetivo: 'Bajar de peso', lleva: ['fit-van', 'crea-30'], normal: 495, oferta: 385 },
    { id: 'musculo', objetivo: 'Ganar músculo', lleva: ['whey-van', 'crea-30'], normal: 640, oferta: 480 },
    { id: 'peso', objetivo: 'Subir de peso', lleva: ['gainer-van', 'crea-30'], normal: 520, oferta: 395 },
];
/** Lo que trae cada combo además del producto, con su valor (hoja de ofertas y Francisco, 25/09). */
exports.REGALOS = [
    { que: 'Batidor', valor: 50 },
    { que: 'App Tu Futuro Físico con IA', valor: 150 },
    { que: 'Envío', valor: 25 },
];
exports.WHATSAPP = '50230712415';
/** El enlace directo a WhatsApp con el mensaje ya escrito. */
function waMe(mensaje) {
    return `https://wa.me/${exports.WHATSAPP}?text=${encodeURIComponent(mensaje)}`;
}
/**
 * El botón de WhatsApp de la app. Pasa por /ir/whatsapp, que anota el toque
 * para el embudo (con la pantalla de origen) y redirige a waMe().
 */
function linkWhatsApp(origen, mensaje) {
    return `/ir/whatsapp?o=${encodeURIComponent(origen)}&t=${encodeURIComponent(mensaje)}`;
}
// ---------------------------------------------------------------------------
// Cotización del pedido
// ---------------------------------------------------------------------------
//
// Los tres combos por objetivo son ofertas Grand Slam: A PROPÓSITO más baratos
// que la escalera, porque dan más valor que el resto (confirmado por Francisco
// el 23/09). Fit Shake + Creatina 30 va a Q385 (la escalera daría Q396), Whey +
// Creatina a Q480 (Q512), Mass Gainer + Creatina a Q395 (Q416). No es un error.
//
// Los combos de 3 de la hoja son el combo Grand Slam más el upsell al 25%,
// redondeado: 480 + 191.25 ≈ 670. Con Fit Shake la escalera del 25% en las tres
// unidades queda más baja que eso (Q562.50 contra Q575), así que la regla es:
// si el pedido arma exactamente un combo, se cobra el MENOR entre la hoja y la
// escalera. La app nunca cobra más que un anuncio ni más que la regla.
/** Lo que se le suma a un combo al 25%: pre entreno, colágeno o aminoácidos. */
exports.UPSELL = ['pre-san', 'pre-man', 'colageno', 'amino'];
/**
 * Combo más un producto al 25% (el precio de 3 unidades de la hoja), con el
 * total al múltiplo de Q5 de abajo. Así salen los de la hoja: Whey + Creatina
 * + Aminos = 480 + 191.67 → Q670; Fit Shake → Q575; Mass Gainer → Q585.
 */
function comboConUpsell(combo, upsellId) {
    const u = exports.PRODUCTOS.find((p) => p.id === upsellId);
    return {
        id: `${combo.id}+${u.id}`,
        objetivo: combo.objetivo,
        lleva: [...combo.lleva, u.id],
        normal: combo.normal + u.normal,
        oferta: Math.floor((combo.oferta + u.total3 / 3) / 5 + 1e-9) * 5,
    };
}
exports.COMBOS_TRES = exports.COMBOS.flatMap((c) => exports.UPSELL.map((u) => comboConUpsell(c, u)));
const productoPorId = (id) => exports.PRODUCTOS.find((p) => p.id === id);
exports.productoPorId = productoPorId;
/** El envase más alto del catálogo (Mass Gainer): es el 100% de la escala. */
exports.ALTO_MAX = Math.max(...exports.PRODUCTOS.map((p) => p.alto));
/** Alto en px de un tarro dibujado a escala, si el más alto mide `base` px. */
const altoEnPx = (p, base) => Math.round((p.alto / exports.ALTO_MAX) * base);
exports.altoEnPx = altoEnPx;
/**
 * Mismo producto, cualquier sabor. Un combo con Whey de vainilla vale igual
 * con Whey de chocolate.
 */
const familia = (p) => `${p.nombre}|${p.servidas}`;
exports.familia = familia;
const redondear = (n) => Math.round(n * 100) / 100;
/**
 * El descuento real de UNA unidad, hacia abajo: nunca anunciar más de lo que
 * es. Creatina 30 es 10.7% y se muestra 10%, no 11%.
 */
function descuentoUnidad(p) {
    return Math.floor(((p.normal - p.unidad) / p.normal) * 100);
}
function familiasDe(ids) {
    return ids
        .map((id) => (0, exports.productoPorId)(id))
        .filter((p) => !!p)
        .map(exports.familia)
        .sort();
}
/**
 * El total por escalera. Un solo producto repetido: el número de la hoja (1, 2
 * o 3 unidades) o el 30% con su regla. Productos mezclados: el descuento del
 * escalón sobre el precio normal del pedido, con la misma regla de redondeo a
 * Q5, una sola vez sobre el total (así no quedan centavos sueltos ni se cobra
 * de más por redondear línea por línea).
 */
function totalEscalera(lineas, unidades, normal) {
    if (unidades === 0)
        return 0;
    if (lineas.length === 1) {
        const { producto: p, cantidad: n } = lineas[0];
        if (n === 1)
            return p.unidad;
        if (n === 2)
            return p.total2;
        if (n === 3)
            return p.total3;
    }
    return totalRedondeado(normal, descuentoPorUnidades(unidades));
}
function cotizar(pedido) {
    const lineasBase = exports.PRODUCTOS.filter((p) => (pedido[p.id] ?? 0) > 0).map((p) => ({
        producto: p,
        cantidad: Math.max(0, Math.floor(pedido[p.id])),
    }));
    const unidades = lineasBase.reduce((s, l) => s + l.cantidad, 0);
    const lineas = lineasBase.map(({ producto, cantidad }) => {
        const unitario = precioUnitario(producto, unidades);
        return {
            producto,
            cantidad,
            unitario,
            subtotal: redondear(unitario * cantidad),
            normal: producto.normal * cantidad,
        };
    });
    const normal = lineas.reduce((s, l) => s + l.normal, 0);
    let total = totalEscalera(lineas, unidades, normal);
    // Las familias del pedido, una por unidad, para compararlas con los combos.
    const delPedido = lineas.flatMap((l) => Array(l.cantidad).fill((0, exports.familia)(l.producto))).sort();
    const igual = (a, b) => a.length === b.length && a.every((x, i) => x === b[i]);
    let combo = null;
    const exacto = exports.COMBOS.find((c) => igual(familiasDe(c.lleva), delPedido)) ??
        exports.COMBOS_TRES.find((c) => igual(familiasDe(c.lleva), delPedido));
    if (exacto && exacto.oferta <= total) {
        total = exacto.oferta;
        combo = { id: exacto.id, objetivo: exacto.objetivo };
    }
    const conRegalos = exports.COMBOS.some((c) => familiasDe(c.lleva).every((f) => delPedido.includes(f)));
    return { lineas, unidades, normal, total, ahorro: redondear(normal - total), combo, conRegalos };
}

return exports;})();
